import { NgModule } from '@angular/core';

import { TestingDirective } from './directives';

@NgModule({
  declarations: [TestingDirective],
  exports: [TestingDirective],
})
export class TestingModule {}
